__turbopack_context__.v({
  "btn": "styles-module__VHwrlG__btn",
  "container": "styles-module__VHwrlG__container",
  "content": "styles-module__VHwrlG__content",
  "description": "styles-module__VHwrlG__description",
  "error": "styles-module__VHwrlG__error",
  "icon": "styles-module__VHwrlG__icon",
  "image": "styles-module__VHwrlG__image",
  "imageContainer": "styles-module__VHwrlG__imageContainer",
});
